---
date: 2024-06-03
title: Indoor= in Catalan
---

The indoor= user interface if now available in Catalan, thanks to [Carlos Sánchez López](https://app.transifex.com/user/profile/erielkhan/).

To translate it in your language, [go to the transifex page](https://explore.transifex.com/indoorequal/indoorequalorg/).
